import { __assign } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'lodash-es';
import TouchGesture from './TouchGesture';
import Hotspot from './Hotspot';
export default function TouchableHotspot(props) {
    var action = props.action, onTouch = props.onTouch;
    return (React.createElement(TouchGesture, { action: action, eventHandler: onTouch },
        React.createElement(Hotspot, __assign({}, props, { onClick: onClick }))));
}
function onClick(e) {
    // This is for preventing the hotspots from flashing when the user taps
    // on them.
    // We need to prevent the event from bubbling up the DOM tree immediately,
    // it would be too late on TouchGesture.eventHandler
    e.stopPropagation();
}
TouchableHotspot.propTypes = {
    action: PropTypes.string.isRequired,
    onTouch: PropTypes.func.isRequired,
};
TouchableHotspot.defaultProps = {
    onTouch: noop,
};
